// src/api/index.js

import axios from 'axios';

let onForbidden = () => {};

// Expose a setter
export const setOnForbidden = (fn) => {
  onForbidden = fn;
};

// Register interceptor once
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const data = error.response.data;
      if (data.message === "Invalid or expired token.") {
        onForbidden();   // ← triggered whenever 403 comes
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
